export default __webpack_public_path__ + "static/media/BEV-Eichamt_Logo_EN_srgb.a8f00d1c.png";